import { render, staticRenderFns } from "./Title_Department.vue?vue&type=template&id=4aeb8dae&scoped=true&"
import script from "./Title_Department.vue?vue&type=script&lang=js&"
export * from "./Title_Department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb8dae",
  null
  
)

export default component.exports